<template>
  <div id="app">
     <TopFloor @keySearch="getKey"></TopFloor>
     <router-view></router-view>
     <Foot></Foot> 
  </div>
</template>
<script>
import TopFloor from './components/top_floor/TopFloor'
import Foot from './components/foot/Foot'
import axios from 'axios'
import Qs from 'qs'
export default {
  data(){
    return {
      select:"",
      pages:30,
      indexs:1,
      classId:422
    }
  },
  components: {
    TopFloor, Foot
  },
  methods:{
    getKey(e){
      // let url = encodeURI(`/ajax/App_Archive.ashx?class_id=${this.classId}&action=list&pageindex=${this.indexs}&pagesize=${this.pages}`)
      // axios.get('/ajax/App_Archive.ashx',{
      //   params:{
      //     class_id:this.classId,
      //     action:'list',
      //     pageindex:this.indexs,
      //     pagesize:this.pages,
      //     keyword:e
      //   }
      // }).then(res=>{
      //   if(res.data.status == 200){
      //     //  this.$router.push({path:'/detail',query:{id:res.data.datalist[0].id,classId:422}})
      //   }
      // })
      this.$store.dispatch('SET_SEARCH',e);
    }
  }
}
</script>
<style>

</style>
